export const GUINEA = {
  code: "GN",
  dial: "+224",
  placeholder: "612345678",
  hint: "9 chiffres (ex. 612 51 64 88) — Guinée uniquement",
  minDigits: 9,
};

export const AUTH_REDIRECT = "/listings";
